import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import ReactDOM from 'react-dom/client'

import { Auth0ProviderWithNavigate } from './auth/components/AuthProviderWithNavigate'
import Providers from './core/components/Providers'
import './index.css'
import { RouterProvider } from './router/components/RouterProvider'
import { Routes } from './router/components/Routes'
import { AlertProvider } from './theme/context/AlertProvider'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: 0,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <Providers>
    <RouterProvider>
      <Auth0ProviderWithNavigate>
        <AlertProvider>
          <QueryClientProvider client={queryClient}>
            <Routes />
          </QueryClientProvider>
        </AlertProvider>
      </Auth0ProviderWithNavigate>
    </RouterProvider>
  </Providers>,
)
